export default "__VITE_ASSET__S6EX$F41__"